<template>
  <div class="app-container shopType">
    <div class="typeHeader">
      <el-button size="small" type="primary" @click="onAdd">新增</el-button>
     
        <div>
        <el-select
            v-model="listQuery.type"
            placeholder="普通"
            :clearable="true"
        >
            <el-option label="普通" value="1"></el-option>
            <el-option label="限购" value="2"></el-option>
        </el-select>

        <el-select
        v-model="listQuery.is_on"
        placeholder="上下架"
        :clearable="true"
    >
        <el-option label="上架中" value="1"></el-option>
        <el-option label="下架" value="0"></el-option>
        </el-select>
        <el-button
        size="small"
        type="primary"
        @click="handleSearch"
        style="margin-left: 10px"
        >搜索</el-button
        >
        </div>
    </div>

    <el-dialog :title="title" v-if="showDialog" :visible.sync="showDialog">
      <el-form ref="form" :model="form" label-width="120px">
        
        <el-form-item label="包名">
          <el-input
            v-model="form.name"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入包名"
          ></el-input>
        </el-form-item>

        <el-form-item label="类型"  >
          <el-select v-model="form.type"  placeholder="学校" :clearable="true"  style="width: 200px" >    
            <!-- <el-option v-for="item in jumpList" :key="item.id" :label="item.name" :value="item.id"></el-option> -->
            <el-option label="普通" :value ="1" ></el-option>
            <el-option label="限购" :value ="2" ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="能量">
          <el-input
            v-model="form.energy"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入能量"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="原价">
          <el-input
            v-model="form.original_price"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入原价"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="现价">
          <el-input
            v-model="form.final_price"
            style="width: 200px"
            :clearable="true"
            placeholder="请输入现价"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="权重" prop="weight">
          <el-input-number
            v-model="form.sort"
            :min="1"
          ></el-input-number>
        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button size="small" @click="handleCancel">返回</el-button>
          <el-button
            size="small"
            @click="handleSubmit"
            type="primary"
            :loading="btnLoading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-table
      :data="list"
      :loading="listLoading"
      border
      fit
      highlight-current-row
      style="margin-top: 15px"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column align="center" label="包名" width="95">
        <template slot-scope="scope">{{ scope.row.name }}</template>
      </el-table-column>
      <el-table-column align="center" label="类型" min-width="200">
        <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type == 1">常规套餐</el-tag>
          <el-tag type="warning" v-else>限购</el-tag></template>
      </el-table-column>
      <el-table-column align="center" label="能量" min-width="110">
        <template slot-scope="scope">{{ scope.row.energy }}</template>
      </el-table-column>
       <el-table-column align="center" label="原价" min-width="110">
        <template slot-scope="scope">{{ scope.row.original_price }}</template>
      </el-table-column>
       <el-table-column align="center" label="现价" min-width="110">
        <template slot-scope="scope">{{ scope.row.final_price }}</template>
      </el-table-column>
       <el-table-column align="center" label="折扣" min-width="110">
        <template slot-scope="scope">{{ scope.row.discount }}</template>
      </el-table-column>

      <el-table-column align="center" label="购买数量" min-width="110">
        <template slot-scope="scope">{{ scope.row.order_count?scope.row.order_count: 0}}</template>
      </el-table-column>

        <el-table-column align="center" label="权重" min-width="110">
        <template slot-scope="scope">{{ scope.row.sort}}</template>
      </el-table-column>

      <el-table-column align="center" label="状态" min-width="110">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.is_on == 1">上架中</el-tag>
          <el-tag type="warning" v-else>已下架</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="400">
        <template slot-scope="scope">
          <el-button size="small" @click="onEdit(scope.row)">修改</el-button>
          <el-button
            size="small"
            :type="scope.row.is_on == 1 ? 'warning' : 'success'"
            @click="handleUpShelf(scope.row)"
            >{{ scope.row.is_on == 1 ? "下架" : "上架" }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total,sizes,prev,pager,next,jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import UploadOne from "@/components/UploadOne/index.vue";
export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      listLoading: true,
      total: null,
      listQuery: {
        page: 1,
        limit: 10,
      },
      form: {
        id:'',
        name:'',
        type:'',
        energy:'',
        original_price:'',
        final_price:''
      },
      jumpList:[
        {id:1,name:'普通'},
        {id:2,name:'限制'},
      ],
      showDialog: false,
      btnLoading: false,
      title: "", // dialog显示的标题
      list: [],
      schools: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    onAdd() {
      this.title = "新增类型";
      this.resetData();
      this.showDialog = true;
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/package/Index",
        method: "get",
        params: this.listQuery,
      })
        .then((result) => {
          this.list = result.data.data;
          this.total = result.data.total;
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally((err) => {
          console.log(err);
        });
    },
    resetData() {
      this.form = {
        id:'',
        name:'',
        type:'',
        energy:'',
        original_price:'',
        final_price:''
      };
    },
    handleSearch() {
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      this.getList();
    },
    handleCancel() {
      this.btnLoading = false;
      this.showDialog = false;
    },
    handleSubmit() {
      if (!this.form.name) {
        this.$message({
          type: "error",
          message: "请填写包名!",
        });
        return;
      } 
      this.btnLoading = true;
      this.$confirm("此操作将修改类目信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((result) => {
          request({
            url: "/api/backend/create/Package",
            method: "post",
            data: this.form,
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            })
            .finally(() => {
              this.btnLoading = false;
              this.showDialog = false;
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
          this.btnLoading = false;
        });
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleUpShelf(row) {
      let self = this;
      let state = !row.status ? "上架" : "下架";
      self
        .$confirm(`此操作将会${state}该商品类型，是否继续`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then((result) => {
          request({
            url: "/api/backend/package/is_on",
            method: "post",
            data: {
              id: row.id,
            },
          })
            .then((result) => {
              this.$notify.success("操作成功");
              this.getList();
            })
            .catch((err) => {
              this.$notify.error("操作失败");
            });
        })
        .catch((err) => {
          this.$notify.info("已取消");
        });
    },

  
    onEdit(row) {
      this.title = "修改";
      this.form = Object.assign({}, row);
      this.showDialog = true;
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.typeHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>
=